










































import Vue from 'vue';
import { FirebaseLesson } from '@/store/types';

export default Vue.extend({
  computed: {
    history(): Array<FirebaseLesson> {
      return this.$store.state.userLessons
        .filter((item: FirebaseLesson) => item.isBookmark !== true)
        .sort((a: FirebaseLesson, b: FirebaseLesson) => b.last_access.seconds
          - a.last_access.seconds).splice(0, 10);
    },
  },
});
